import { faker } from '@faker-js/faker';

import type { ToggleDocumentUnreadPostResponse } from '../types/ToggleDocumentUnreadPostResponse';

export function createToggleDocumentUnreadPostResponse(
  data: NonNullable<Partial<ToggleDocumentUnreadPostResponse>> = {}
): NonNullable<ToggleDocumentUnreadPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
